/**
 * The current route, as React state.
 *
 * `useSyncExternalStore` rather than a `useEffect` listener: the hash is external state that
 * can change before React has hydrated — someone opening a shared link lands mid-render — and
 * this is the API built for exactly that. An effect-based listener drops the first value.
 */
import { useSyncExternalStore } from 'react'

import { parse, type Route } from './routes'

function subscribe(onChange: () => void): () => void {
  window.addEventListener('hashchange', onChange)
  return () => window.removeEventListener('hashchange', onChange)
}

function snapshot(): string {
  return window.location.hash
}

export function useRoute(): Route {
  const hash = useSyncExternalStore(subscribe, snapshot, () => '')
  return parse(hash)
}
